
export default {
  props: {
    colorProp: {
      type: String,
      default: "#A4A4A4"
    },
    isOutlined: {
      type: Boolean,
      default: true
    },
    backRoute: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleBack() {
      if (this.backRoute) {
        this.$router.push(this.backRoute);
      } else {
        this.$router.back();
      }
    }
  }
};
